module.exports = __webpack_public_path__ + "static/img/shuziyingxiao_10.6cd158c7.jpg";